export const SU_API_BASE = '/seller-university/api';
export const SU_API = {
  LEARNING_PATHWAY: `${SU_API_BASE}/learning-pathway`,
  LEARNING_PATHWAY_STATIC: `${SU_API_BASE}/learning-pathway-static`,
  CONTENT_PROGRESS: `${SU_API_BASE}/content-progress`,
  LIST_TOPICS: `${SU_API_BASE}/topics`,
  LIST_LEARNING_PATHWAYS: `${SU_API_BASE}/learning-pathways-static`,
  LIST_LEARNING_PATHWAYS_POLY: `${SU_API_BASE}/learning-pathways`,
  TOPIC: `${SU_API_BASE}/topic`,
  TOPIC_FILTER: `${SU_API_BASE}/topic/filter`,
  LIST_LEARNING_MODULES: `${SU_API_BASE}/modules`,
  LIST_MODULE_CARDS: `${SU_API_BASE}/module-cards`,
  LEARNING_MODULE: `${SU_API_BASE}/module`,
  CUSTOMER_CREDENTIAL: `${SU_API_BASE}/credential`,
  ASSESSMENT_START: `${SU_API_BASE}/credential/assessment/start`,
  ASSESSMENT_ANSWER: `${SU_API_BASE}/credential/assessment/answer`,
  ASSESSMENT_SUBMIT: `${SU_API_BASE}/credential/assessment/submit`,
  SEARCH: `${SU_API_BASE}/search`,
  AUTOCOMPLETE: `${SU_API_BASE}/autocomplete`,
  AUTOCOMPLETE_V2: `${SU_API_BASE}/autocomplete-v2`,
  LIST_WEBINARS: `${SU_API_BASE}/webinars`,
  REGISTER_WEBINAR: `${SU_API_BASE}/webinar/register`,
  SELLER_CONTEXT: `${SU_API_BASE}/seller-context`,
};
export const HOMEPAGE_CAROUSEL_ID = 'su-campus-homepage-carousel';

export const API_SEARCH_PARAMS = {
  LEARNING_PATHWAY_ID: 'learningPathwayId',
  CREDENTIAL_ID: 'credentialId',
  CLIENT_ID: 'clientId',
  QUERY: 'query',
  SEARCH_TEXT: 'searchText',
  PAGE_NUMBER: 'pageNumber',
  PAGE_SIZE: 'pageSize',
  MODULE_ID: 'moduleId',
  TOPIC_ID: 'topicId',
  QUERY_TYPE: 'queryType',
  SUBTOPIC_ID: 'subtopicId',
  TAG_ID: 'tagId',
  WEBINAR_CLIENT_ID: 'webinarClientId',
  METADATA_ONLY: 'metadataOnly',
  SEL_LOCALE: 'sel_locale',
  CAROUSEL_ID: 'carouselId',
};

export const URL_SEARCH_PARAMS = {
  MONS_SEL_LOCALE: 'mons_sel_locale',
  MONS_SEL_MKID: 'mons_sel_mkid',
  MONS_SEL_MCID: 'mons_sel_mcid',
  IGNORE_SELECTION_CHANGED: 'ignore_selection_changed',
};

export const API_DEFAULTS = {
  MARKETPLACE_ID: 'ATVPDKIKX0DER',
  LOCALE: 'en_US',
};

export const WEBINAR_CONFIG = {
  CLIENT_ID: 'bba9ac45-1bd8-4347-81e7-ae09c360d01d',
};

export const AUTOCOMPLETE_PARAM = {
  MAX_RESULTS: 10,
  THROTTLE_MS: 300,
  DISABLED: false,
  ARIA_LABEL: '',
};

export const AUTOCOMPLETE_V2_PARAM = {
  MAX_SUGGESTIONS: 10,
  MAX_MODULES: 2,
  THROTTLE_MS: 300,
  DISABLED: false,
  ARIA_LABEL: '',
};

export const HMD_SURVEY_SUBMIT_URL = '/gp/satisfaction/survey-submit.html';
